import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/features/esim/EsimGuide.jsx");
